<div class="component-wrapper d-block h-100 pointer-events-none" [ngStyle]="contentStyle">
  @if (widgetConfig.inputFieldSettings?.isAllowed) {
  <div
    class="search-input d-flex"
    [ngStyle]="{ 'justify-content': widgetConfig.inputFieldSettings?.css_config?.inputPosition ?? 'start' }"
  >
    <div [ngStyle]="{ width: widgetConfig.inputFieldSettings?.css_config?.inputWidth + '%' || '100%' }">
      <finxone-input
        type="text"
        [label]="widgetConfig.inputFieldSettings?.label ?? ''"
        (input)="searchBanks($event)"
      >
        <span prefix #prefix class="prefix-icon" *ngIf="widgetConfig.icon">
          <mat-icon [svgIcon]="widgetConfig.icon" [ngStyle]="searchIconStyle"></mat-icon> </span
      ></finxone-input>
    </div>
  </div>
  <div class="py-5"></div>
  } @if (filteredList?.length) {
  <div
    class="list-wrapper pb-2"
    id="bank-listing"
    [ngStyle]="
      !pageConfig?.isUsingHtmlStructure
        ? { 'max-height': widgetConfig.inputFieldSettings?.isAllowed ? '85%' : 'unset' }
        : { 'max-height': containerHeight }
    "
  >
    <div class="grid gap-4" [ngStyle]="gridStyles">
      @for (bank of filteredList; track bank.id; ) {
      <div class="mb-5">
        <div
          [ngStyle]="textContentStyle"
          class="pointer-events-none"
          [innerHTML]="createTemplateData(bank, $index) | safeHtml"
          (click)="proceedWithBank(bank)"
        ></div>
      </div>
      } @empty { @if (searchText.length) {
      <div class="col-12">
        <ng-container
          *ngTemplateOutlet="emptySearchResults; context: { searchText: searchText }"
        ></ng-container>
      </div>
      } @else if (isApiInProgress) {
      <div [innerHTML]="renderFetchingTemplate() | safeHtml"></div>
      } @else {
      <div [innerHTML]="renderNoRecordsTemplate() | safeHtml"></div>
      } }
    </div>
  </div>
  } @else { @if (searchText.length) {
  <ng-container *ngTemplateOutlet="emptySearchResults; context: { searchText: searchText }"></ng-container>
  } @else if (isApiInProgress) {
  <div [innerHTML]="renderFetchingTemplate() | safeHtml"></div>
  } @else {
  <div [innerHTML]="renderNoRecordsTemplate() | safeHtml"></div>
  } }
</div>

<ng-template #emptySearchResults let-searchText="searchText">
  <div class="empty-screen-msg">
    <div class="is-center mb-3">
      <mat-icon [svgIcon]="'exclamation-circle'"></mat-icon>
    </div>
    <p>
      No results found for <b>{{ '"' + searchText + '"' }}</b
      >. Check the spelling or try another search.
    </p>
  </div>
</ng-template>
